<template>
  <ClientCreatePassport/>
  <transition name="fade">
    <div v-if="show" class="modal d-block">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">

          <!-- HEADER -->
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isEdit ? 'Редактировать клиента' : 'Добавить клиента' }}
            </h5>
            <button class="close" @click="close">&times;</button>
          </div>

          <!-- BODY -->
          <div class="modal-body">
            <CircleProgress v-if="loading"/>

            <form v-else @submit.prevent="submit">

              <div class="d-flex">
                <!-- FOOTER -->
                <div class="col-md-6">
                  <argon-switch
                      id="isLegalEntity"
                      :checked="form.isLegalEntity"
                      :disabled="isEdit"
                      @change="onLegalEntityChange"
                  >
                    Юридическое лицо
                  </argon-switch>
                </div>
                <div class="col-md-6">
                  <argon-button type="submit">
                    {{ isEdit ? 'Сохранить' : 'Добавить' }}
                  </argon-button>
                </div>
              </div>
              <!-- ===== ОСНОВНАЯ СЕТКА ===== -->
              <div class="row">

                <!-- ========================= -->
                <!-- ===== ФИЗ ЛИЦО БЛОК ===== -->
                <!-- ========================= -->

                <div :class="form.isLegalEntity ? 'col-lg-4' : 'col-12'">

                  <h6 class="mb-3">Физическое лицо</h6>

                  <div class="row">

                    <!-- Левая колонка физ.лица -->
                    <div class="col-md-6">

                      <div class="mb-3">
                        <label>ФИО *</label>
                        <argon-input-new v-model="form.fullName" required/>
                      </div>

                      <div class="mb-3">
                        <label>Дата рождения</label>
                        <input type="date" class="form-control" v-model="form.birthdate"/>
                      </div>

                      <div class="mb-3">
                        <label>Номер паспорта</label>
                        <argon-input-new
                            v-model="form.passportNumber"
                            @blur="searchInBlackList(form.passportNumber)"
                        />
                      </div>

                      <div class="mb-3">
                        <label>Дата выдачи</label>
                        <input type="date" class="form-control"
                               v-model="form.passportIssueDate"/>
                      </div>

                    <div class="mb-3">
                      <label>Орган выдачи</label>
                      <PasportIssuerSelect
                          v-model="form.passportIssuingAuthorityId"
                          url="/api/clients/pasport_autors"
                          create-url="/api/clients/passport-issuer-create"
                      />
                    </div>
                   </div>
                    <!-- Правая колонка физ.лица -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label>Адрес регистрации</label>
                        <argon-input-new v-model="form.registrationAddress"/>
                      </div>

                      <div class="mb-3">
                        <label>Адрес проживания</label>
                        <argon-input-new v-model="form.address"/>
                      </div>

                      <div class="mb-3">
                        <label>Телефон</label>
                        <argon-input-new
                            v-model="form.phone"
                            @blur="searchInBlackList(form.phone)"
                        />
                      </div>

                      <div class="mb-3">
                        <label>Доп. телефон</label>
                        <argon-input-new
                            v-model="form.additionalPhone"
                            @blur="searchInBlackList(form.additionalPhone)"
                        />
                      </div>

                      <div class="mb-3">
                        <label>Email</label>
                        <argon-input-new v-model="form.email"/>
                      </div>


                    </div>
                  </div>
                  <!-- Черный список -->
                  <div v-if="blackList.length" class="alert alert-warning mt-2">
                    Совпадения в чёрном списке:
                    <div v-for="(item, i) in blackList" :key="i">
                      {{ i + 1 }}. {{ item.client.fullName }} — {{ item.reason }}
                    </div>
                  </div>

                </div>

                <!-- ========================= -->
                <!-- ===== ЮР ЛИЦО БЛОК ===== -->
                <!-- ========================= -->

                <div v-if="form.isLegalEntity" class="col-lg-8">

                  <h6 class="mb-3">Юридическое лицо</h6>

                  <div class="row">

                    <!-- Левая колонка юрлица -->
                    <div class="col-md-6">

                      <div class="mb-3">
                        <label>Название компании</label>
                        <argon-input-new v-model="form.companyName"/>
                      </div>

                      <div class="mb-3">
                        <label>Представитель</label>
                        <argon-input-new v-model="form.authorizedPerson"/>
                      </div>

                      <div class="mb-3">
                        <label>Основание</label>
                        <argon-input-new v-model="form.authorityBasis"/>
                      </div>

                      <div class="mb-3">
                        <label>Юридический адрес</label>
                        <argon-input-new v-model="form.legalAddress"/>
                      </div>

                    </div>

                    <!-- Правая колонка юрлица -->
                    <div class="col-md-6">

                      <div class="mb-3">
                        <label>Телефон компании</label>
                        <argon-input-new v-model="form.companyPhone"/>
                      </div>

                      <div class="mb-3">
                        <label>УНП / ИНН</label>
                        <argon-input-new v-model="form.unpOrItn"/>
                      </div>

                      <div class="mb-3">
                        <label>Банковский счёт</label>
                        <argon-input-new v-model="form.bankAccount"/>
                      </div>

                      <!-- BIC -->
                      <div class="mb-3 position-relative">
                        <label>БИК</label>
                        <input
                            class="form-control"
                            v-model="form.bankBIC"
                            @focus="showBicOptions = true"
                            @blur="hideBicOptions"
                        />

                        <ul v-if="showBicOptions" class="options-list">
                          <li
                              v-for="bic in filteredBics"
                              :key="bic"
                              @click="selectBic(bic)"
                          >
                            {{ bic }}
                          </li>
                        </ul>
                      </div>

                      <div class="mb-3">
                        <label>Дата счёта</label>
                        <input type="date" class="form-control"
                               v-model="form.invoiceDate"/>
                      </div>

                    </div>

                  </div>
                </div>

              </div>
              <div class="mb-6">
                <label>Дополнительная информация</label>
                <argon-input-new v-model="form.workInfo"/>
              </div>

            </form>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from '@/axios'
import CircleProgress from '../CircleProgress.vue'
import ArgonButton from "@/components/ArgonButton.vue"
import ArgonInputNew from "@/components/ArgonInputNew.vue"
import ClientCreatePassport from "@/views/components/ClientSteps/ClientCreatePassport.vue";
import PasportIssuerSelect from "@/components/PasportIssuerSelect.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";

export default {
  name: 'ClientFormModal',
  components: {ArgonSwitch, PasportIssuerSelect, ClientCreatePassport, ArgonInputNew, ArgonButton, CircleProgress},

  props: {
    show: Boolean,
    clientId: {type: Number, default: null}
  },

  data() {
    return {
      loading: false,
      blackList: [],
      passportAuthors: [],
      selectedAuthor: null,
      passportAuthorFilter: '',
      showAuthorOptions: false,
      authorPage: 1,
      authorLastPage: 1,
      authorSearch: '',
      loadingAuthors: false,
      observer: null,
      showBicOptions: false,
      bankBics: [
        'AKBBBY2X', 'ALFABY2X', 'BELBBY2X', 'BLBBBY2X',
        'BPSBBY2X', 'BPSBBY2XMTT', 'BRBMBY2X', 'COMEBY2X',
        'MTBKBY22', 'OLMPBY2X', 'PARXBY22', 'PJCBBY2X',
        'PRIORBY2X', 'RSHNBY2X', 'RRBBBY2X', 'SLANBY22',
        'SSISBY25', 'TECNBY22', 'UNBSBY2X', 'ZEPTBY2X'
      ],
      form: this.emptyForm()
    }
  },

  computed: {
    isEdit() {
      return this.clientId !== null
    },

    filteredBics() {
      if (!this.form.bankBIC) return this.bankBics
      return this.bankBics.filter(b =>
          b.toLowerCase().includes(this.form.bankBIC.toLowerCase())
      )
    }
  },

  watch: {
    clientId: {
      immediate: true,
      handler(id) {
        if (id) {
          this.loadClient(id)
        } else {
          this.form = this.emptyForm()
        }
      }
    },
    selectedAuthor(val) {
      this.form.passportIssuingAuthorityId = val
    }
  },

  methods: {
    emptyForm() {
      return {
        id: null,
        fullName: '',
        birthdate: '',
        isLegalEntity: false,
        phone: '',
        additionalPhone: '',
        email: '',
        address: '',
        registrationAddress: '',
        workInfo: '',
        passportNumber: '',
        passportIssueDate: '',
        passportIssuingAuthorityId: null,
        passportScan: null,
        companyName: '',
        authorizedPerson: '',
        authorityBasis: '',
        legalAddress: '',
        companyPhone: '',
        unpOrItn: '',
        bankAccount: '',
        bankBIC: '',
        invoiceDate: ''
      }
    },
    onLegalEntityChange(event) {
      if (this.isEdit) {
        return
      }

      this.form.isLegalEntity = event.target.checked
    },

    selectBic(bic) {
      this.form.bankBIC = bic
      this.showBicOptions = false
    },

    hideBicOptions() {
      setTimeout(() => {
        this.showBicOptions = false
      }, 150)
    },

    // ===== CLIENT LOAD =====

    async loadClient(id) {
      this.loading = true

      const {data} = await axios.get(`/api/clients/${id}`)
      const client = data.data

      Object.assign(this.form, {
        ...this.emptyForm(),
        ...client,
        ...client.personal,
        ...client.legal
      })

      if (client.personal?.passportIssueDate)
        this.form.passportIssueDate =
            client.personal.passportIssueDate.slice(0, 10)

      if (client.legal?.invoiceDate)
        this.form.invoiceDate =
            client.legal.invoiceDate.slice(0, 10)

      // ===== Подгрузка выбранного органа =====
      if (this.form.passportIssuingAuthorityId) {
        try {
          const { data } = await axios.get('/api/clients/pasport_autors', {
            params: {
              id: this.form.passportIssuingAuthorityId
            }
          })

          if (data.data.length) {
            const author = data.data[0]

            this.passportAuthors = [author]
            this.selectedAuthor = author.id
          }

        } catch (e) {
          console.error('Ошибка подгрузки выбранного органа', e)
        }
      }

      this.loading = false
    },

    // ===== BLACKLIST =====

    async searchInBlackList(value) {
      if (!value) {
        this.blackList = []
        return
      }

      const {data} =
          await axios.get(`/api/clients/get-blacklist?search=${value}`)

      this.blackList = data.data
    },

    // ===== FILE =====

    previewImage(e) {
      const file = e.target.files[0]
      if (!file) return

      const reader = new FileReader()
      reader.onload = ev => {
        this.form.passportScan = ev.target.result
      }
      reader.readAsDataURL(file)
    },

    clearImage() {
      this.form.passportScan = null
      this.$refs.fileInput.value = null
    },

    // ===== SUBMIT =====

    async submit() {
      this.loading = true

      try {
        let response

        if (this.isEdit) {
          response = await axios.put(`/api/clients/new/${this.clientId}`, this.form)
          this.$emit('saved', response.data.data)
        } else {
          response = await axios.post('/api/clients/client/add', this.form)

          var createdClientId = response.data &&
          response.data.data &&
          response.data.data.client_id
              ? response.data.data.client_id
              : null

          if (createdClientId) {
            const clientResponse = await axios.get(`/api/clients/${createdClientId}`)
            const createdClient = clientResponse.data.data || clientResponse.data
            this.$emit('saved', createdClient)
          } else {
            this.$emit('saved', null)
          }
        }

        this.close()
      } catch (error) {
        console.error('Ошибка сохранения клиента:', error)
      } finally {
        this.loading = false
      }
    },

    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-body {
  max-height: 75vh;
  overflow-y: auto;
}

.options-list {
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  padding-left: 0;
  border: 1px solid #d2d6da;
  border-radius: 0.5rem;
  background-color: white;
  z-index: 1;
  top: 100%;
  margin-top: 0.25rem;
}

.options-list li {
  padding: 5px;
  cursor: pointer;
}

.options-list li:hover {
  background: #eee;
}

.passport-preview {
  position: relative;
  width: 220px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dee2e6;
}

.passport-preview img {
  width: 100%;
  display: block;
  object-fit: cover;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  cursor: pointer;
  font-size: 14px;
  line-height: 26px;
  padding: 0;
}
.mb-3{
  margin-bottom: 1px !important;
}
.mb-3 label{
  margin-bottom: 1px !important;
}
.mb-6 {
  margin-bottom: 2px !important;
}
</style>